module.exports = "<h1 id=\"单选--d-radio\">单选  d-radio</h1>\n";